import { Navbar, Button } from "react-bootstrap";
import { UserMenu } from "../user";
import { useAuthStore } from "@/features/auth";
import { Boxes, ChatQuote, Messenger } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

export const Header = () => {
  const { user } = useAuthStore();
  const { isAuthorized } = useAuthStore();

  return (
    <Navbar
      variant="light"
      style={{ backgroundColor: "#d5d5d5", padding: "6px 20px" }}
      expand="lg"
    >
      <Navbar.Brand style={{ height: 28, display: "contents" }} href="/">
        <Messenger fill="#6c757d" />
      </Navbar.Brand>

      <div
        style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "12px" }}
      >
        {isAuthorized && user ? (
          <>
            <Link
              to="/contacts"
              style={{ color: "#495057", fontSize: 12, textDecoration: "none" }}
            >
              Контакты
            </Link>
            <UserMenu user={user} />
          </>
        ) : (
          <>
            <Button href="/login" variant="outline-dark" size="sm">
              Войти
            </Button>
            <Button href="/register" variant="dark" size="sm">
              Зарегистрироваться
            </Button>
          </>
        )}
      </div>
    </Navbar>
  );
};
